import React from 'react';
import { useProduct } from '../../hooks/useProduct';
import Icon from 'components/icons';
import * as styles from './ValueBullets.module.scss';
import { SKU_HARDCOVER, SKU_PHOTO_WRAPPED_HARDCOVER, SKU_PHOTO_WRAPPED_LAYFLAT } from 'components/constants/products';

export const ValueBullets: React.FC = () => {
  const { product } = useProduct();

  const pageText = getPageText(product.sku);

  return (
    <div className={styles.container}>
      <div className={styles.row}>
        <Icon icon="openBook" size="tiny" viewBox="0 0 20 20" />
        {pageText}
      </div>

      <div className={styles.row}>
        <Icon icon="package" size="tiny" viewBox="0 0 20 20" />
        Handcrafted in the USA
      </div>
    </div>
  );
};

const getPageText = (sku: string) => {
  switch (sku) {
    case SKU_PHOTO_WRAPPED_HARDCOVER:
      return '24-210 pages, best for 24-500 images';
    case SKU_PHOTO_WRAPPED_LAYFLAT:
      return '20-100 pages, best for 20-200 images';
    case SKU_HARDCOVER:
      return '40-210 pages, best for 40-500 images';
  }
};
